import {
    CUSTOMER_ACCESS,
    CUSTOMER_ACCOUNTS,
    CUSTOMER_BUSINESS,
    CUSTOMER_BUSINESS_PRIMARY,
    CUSTOMER_DIRECT_DEBIT,
    CUSTOMER_DIRECT_DEBIT_CONFIRM,
    CUSTOMER_DIRECT_DEBIT_DELETE,
    CUSTOMER_DOMESTIC,
    CUSTOMER_DONATION,
    CUSTOMER_FILE__DELETE,
    CUSTOMER_FILE__GET_ONE,
    CUSTOMER_FILE__GET_UPLOAD,
    CUSTOMER_IMAGE,
    CUSTOMER_INVENTORY__GET_POST,
    CUSTOMER_INVENTORY__PATCH_DELETE,
    CUSTOMER_LINK_RESERVATION,
    CUSTOMER_MOVE_IN_DATE_PATCH,
    CUSTOMER_PEOPLE,
    CUSTOMER_PERSON,
    CUSTOMER_RESERVATION,
    CUSTOMER_SECURITY_QUESTIONS,
    CUSTOMER_STATUS,
    CUSTOMER_STORAGE_AGREEMENT,
    CUSTOMER_SUBCONTRACTS,
    CUSTOMER_SUBCONTRACTS__PATCH,
    CUSTOMER_SUBCONTRACTS_REASONS,
    CUSTOMER_TERMS,
    LOGGER,
    MOVE_IN_BLOCKED_DATES,
    PASSWORD_VERIFY,
    SITE_UNDER_MAINTENANCE,
    STORE_GET,
    USER,
    YOTI_ACCOUNT_HOLDER_PROGRESS,
} from './endpoints';

export const site_under_maintenance = (request) => {
    try {
        return request.get(SITE_UNDER_MAINTENANCE);
    } catch (e) {
        console.debug(e);
    }
};


/**
 * Retrieve customer details
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
 *     "customerId": "md023bf9a",
 * }
 */
export const retrieve = (request, payload) => {
    try {
        const { customerId } = payload;
        const URL = CUSTOMER_DOMESTIC.replace('{customer_id}', customerId);

        return request.get(URL);
    } catch (e) {
        console.debug(e);
    }
};

/**
 * Retrieve customer business details
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
 *     "customerId": "md023bf9a",
 * }
 */
export const retrieve_business = (request, payload) => {
    try {
        const { customerId } = payload;
        const URL = CUSTOMER_BUSINESS.replace('{customer_id}', customerId);

        return request.get(URL);
    } catch (e) {
        console.debug(e);
    }
};


/**
 * Update customer details
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {{
 *     "customerId": "string",
 *     "firstName": "string",
 *     "lastName": "string",
 *     "extendedAccess": true,
 *     "primaryPhone": "string",
 *     "alternativePhone": "string"
 *     "email": "string",
 *  "mainAddress1": "string",
 *  "mainAddress2": "string",
 *  "mainTown": "string",
 *  "mainCounty": "string",
 *  "mainPostCode": "string",
 *  "invoiceAddress1": "string",
 *  "invoiceAddress2": "string",
 *  "invoiceTown": "string",
 *  "invoiceCounty": "string",
 *  "invoicePostCode": "string",
 *   }
 */
export const update = (request, payload) => {
    try {
        const { customerId } = payload;
        const URL = CUSTOMER_DOMESTIC.replace('{customer_id}', customerId);
        return request.patch(URL, payload);
    } catch (e) {
        console.debug(e);
    }
};


/**
 *
 * @param request
 * @param payload
 * @returns {Promise<AxiosResponse<T>>}
 *
 *@example payload = {
 *  "customerId": "string",
 *  "mainAddress1": "string",
 *  "mainAddress2": "string",
 *  "mainTown": "string",
 *  "mainCounty": "string",
 *  "mainPostCode": "string",
 *  "invoiceAddress1": "string",
 *  "invoiceAddress2": "string",
 *  "invoiceTown": "string",
 *  "invoiceCounty": "string",
 *  "invoicePostCode": "string",
 *  "extendedAccess": true,
 *  "companyName": "string",
 *  "companyRegistrationNumber": "string",
 *  "accountsDepartmentPhone": "string",
 *   "mainSwitchBoardPhone": "string"
 *   }
 *
 */

export const update_business = (request, payload) => {
    try {
        const { customerId } = payload;
        const URL = CUSTOMER_BUSINESS.replace('{customer_id}', customerId);

        return request.patch(URL, payload);
    } catch (e) {
        console.debug(e);
    }
};

/**
 * Bit-field of check-in status flags
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
 *     "customerId": "md023bf9a",
 * }
 */
export const status__get = (request, payload) => {
    try {
        const { customerId } = payload;
        const URL = CUSTOMER_STATUS.replace('{customer_id}', customerId);

        return request.get(URL);
    } catch (e) {
        console.debug(e);
    }
};

/**
 * IMPORTANT ! According to https://gitlab.com/bigyellow-group/bigyellow-backend/-/blob/master/doc/api.yaml#L1397-1425
 * when we "force update", we need to rename the fields by prefixing them
 * with `update` prefix. e.g. updateSecurityQuestions
 *
 * @param request
 * @param payload
 * @returns {*}
 */
export const status__set = (request, payload) => {
    try {
        const {customerId, forceUpdate} = payload;

        if (forceUpdate) {
            let newPayload = {};

            Object.keys(payload).map(key => {
                let newKey = `update${key.charAt(0).toUpperCase()}${key.slice(1)}`;
                newPayload[newKey] = payload[key];
            });

            payload = newPayload;
        }

        const URL = CUSTOMER_STATUS.replace('{customer_id}', customerId);

        return request.post(URL, payload);
    } catch (e) {
        console.debug(e);
    }
};

/**
 * Additional reservation information for pre-filling inputs
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
 *     "customerId": "md023bf9a",
 * }
 */
export const reservation__get = (request, payload) => {
    try {
        const { customerId } = payload;
        const URL = CUSTOMER_RESERVATION.replace('{customer_id}', customerId);

        return request.get(URL);
    } catch (e) {
        console.debug(e);
    }
};

/**
 * Retrieve customer image
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
 *     "customerId": "md023bf9a",
 *     "tag": "photo"
 * }
 */
export const image__get = (request, payload) => {
    try {
        const { customerId, tag } = payload;
        const URL = CUSTOMER_IMAGE.replace('{customer_id}', customerId).replace(
            '{tag}',
            tag
        );

        return request.get(URL);
    } catch (e) {
        console.debug(e);
    }
};

/**
 * Upload customer image
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
 *     "customerId": "md023bf9a",
 *     "tag": "photo",
 *     "data": base64 image data
 * }
 */
export const image__upload = (request, payload) => {
    try {
        const { customerId, tag, data } = payload;
        const URL = CUSTOMER_IMAGE.replace('{customer_id}', customerId).replace(
            '{tag}',
            tag
        );

        return request.patch(URL, { data: data });
    } catch (e) {
        console.debug(e);
    }
};

/**
 * Retrieve customer security questions
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
 *     "customerId": "md023bf9a",
 * }
 */
export const security_questions__get = (request, payload) => {
    try {
        const { customerId } = payload;
        const URL = CUSTOMER_SECURITY_QUESTIONS.replace(
            '{customer_id}',
            customerId
        );

        return request.get(URL);
    } catch (e) {
        console.debug(e);
    }
};

/**
 * Update customer security questions
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
 *     "customerId": "md023bf9a",
 *     "memorableWordHint": "string",
 *     "memorableWord": "string",
 *     "dateOfBirth": "2020-07-27"
 * }
 */
export const security_questions__set = (request, payload) => {
    try {
        const { customerId } = payload;
        const URL = CUSTOMER_SECURITY_QUESTIONS.replace(
            '{customer_id}',
            customerId
        );

        delete payload.customerId;

        return request.patch(URL, payload);
    } catch (e) {
        console.debug(e);
    }
};

/**
 * Retrieve customer access data
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
 *     "customerId": "md023bf9a",
 * }
 */
export const access__get = (request, payload) => {
    try {
        const { customerId } = payload;
        const URL = CUSTOMER_ACCESS.replace('{customer_id}', customerId);

        return request.get(URL);
    } catch (e) {
        console.debug(e);
    }
};

/**
 * Set customer access data
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
 *     "customerId": "md023bf9a",
 *     "extendedAccess": true,
 *     "accessCode": "string"
 * }
 */
export const access__set = (request, payload) => {
    try {
        const { customerId } = payload;
        const URL = CUSTOMER_ACCESS.replace('{customer_id}', customerId);

        delete payload.customerId;

        return request.patch(URL, payload);
    } catch (e) {
        console.debug(e);
    }
};

/**
 * Retrieve customer people
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
 *     "customerId": "md023bf9a",
 * }
 */
export const people__read = (request, payload) => {
    try {
        const { customerId } = payload;
        const URL = CUSTOMER_PEOPLE.replace('{customer_id}', customerId);

        return request.get(URL);
    } catch (e) {
        console.debug(e);
    }
};

/**
 * Set customer people
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
 *     "customerId": "md023bf9a",
 *     "name": "string",
 *     "email": "string",
 *     "primaryPhone": "string",
 *     "alternatePhone": "string",
 *     "emergencyContact": true,
 *     "roomAccess": true,
 *     "association": "string"
 * }
 */
export const people__create = (request, payload) => {
    try {
        const { customerId } = payload;
        const URL = CUSTOMER_PEOPLE.replace('{customer_id}', customerId);

        delete payload.customerId;

        return request.post(URL, payload);
    } catch (e) {
        console.debug(e);
    }
};

/**
 * Update person
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
 *     "personId": "md023bf9a",
 *     "name": "string",
 *     "email": "string",
 *     "primaryPhone": "string",
 *     "alternatePhone": "string",
 *     "emergencyContact": true,
 *     "roomAccess": true,
 *     "association": "string"
 * }
 */
export const people__update = (request, payload) => {
    try {
        const { personId, customerId } = payload;
        let URL = CUSTOMER_PERSON.replace('{person_id}', personId);
        URL = URL.replace('{customer_id}', customerId);

        delete payload.personId;

        return request.patch(URL, payload);
    } catch (e) {
        console.debug(e);
    }
};

/**
 * Delete person
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
 *     "personId": "md023bf9a",
 * }
 */
export const people__delete = (request, payload) => {
    try {
        const { personId, customerId } = payload;
        let URL = CUSTOMER_PERSON.replace('{person_id}', personId);
        URL = URL.replace('{customer_id}', customerId);

        return request.delete(URL);
    } catch (e) {
        console.debug(e);
    }
};

/**
 * Set a direct debit
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
 *     "personId": "md023bf9a",
 *     "accountHolder": "string",
 *     "accountNumber": "string",
 *     "sortCode": "string",
 *     "bank": "string"
 * }
 */
export const direct_debit__set = (request, payload) => {
    try {
        const { customerId } = payload;
        const URL = CUSTOMER_DIRECT_DEBIT.replace('{customer_id}', customerId);
        payload.accountSortCode = payload.accountSortCode.split('-').join("");
        delete payload.customerId;

        return request.post(URL,payload);
    } catch (e) {
        console.debug(e);
    }
};

/**
 * Retrieve customer direct debit
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
 *     "customerId": "md023bf9a",
 * }
 */
export const direct_debit__get = (request, payload) => {
    try {
        const { customerId } = payload;

        const URL = CUSTOMER_DIRECT_DEBIT.replace('{customer_id}', customerId);

        return request.get(URL);
    } catch (e) {
        console.debug(e);
    }
};

/**
 *
 * @param request
 * @param payload
 * @returns {*}
 */
export const direct_debit__delete = (request, payload) => {
    try {
        const { directDebitId, customerId } = payload;

        //directDebitId is equal to null for declined details
        let URL = CUSTOMER_DIRECT_DEBIT;
        if(directDebitId &&directDebitId !=='') {
            URL = CUSTOMER_DIRECT_DEBIT_DELETE.replace('{directDebitId}', directDebitId);
        }
        URL = URL.replace('{customer_id}', customerId);

        return request.delete(URL);
    } catch (e) {
        console.debug(e);
    }
};

/**
 *
 * @param request
 * @param payload
 * @returns {*}
 */
export const direct_debit__confirm = (request, payload) => {
    try {
        const { customerId ,token} = payload;
        const URL = CUSTOMER_DIRECT_DEBIT_CONFIRM.replace('{customer_id}', customerId).replace('{token}', token);
        delete payload.customerId;
        delete payload.token;
        return request.post(URL,payload);
    } catch (e) {
        console.debug(e);
    }
};


/**
 * Set customer agreement
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
 *     "customerId": "md023bf9a",
 * }
 */
export const agreement__set = (request, payload) => {
    try {
        const { customerId } = payload;
        const URL = CUSTOMER_STORAGE_AGREEMENT.replace(
            '{customer_id}',
            customerId
        );

        delete payload.customerId;

        return request.post(URL,payload);
    } catch (e) {
        console.debug(e);
    }
};


/**
 * Get customer terms status
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
 *     "customerId": "md023bf9a",
 * }
 */
export const terms__get = (request, payload) => {
    try {
        const {customerId} = payload;
        const URL = CUSTOMER_TERMS.replace(
            '{customer_id}',
            customerId
        );

        delete payload.customerId;

        return request.get(URL, payload);
    } catch (e) {
        console.debug(e);
    }
};

/**
 * Get customer inventory
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
 *     "customerId": "md023bf9a",
 * }
 */
export const customer_inventory__get = (request, payload) => {
    try {
        const { customerId } = payload;
        const URL = CUSTOMER_INVENTORY__GET_POST.replace(
            '{customer_id}',
            customerId
        );

        return request.get(URL);
    } catch (e) {
        console.debug(e);
    }
};

/**
 * Add customer inventory item
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
 *     "customerId": "md023bf9a",
 *     "name": "string",
 *     "quantity": 0,
 *     "value": 0
 * }
 */
export const customer_inventory__create = (request, payload) => {
    try {
        const { customerId } = payload;
        const URL = CUSTOMER_INVENTORY__GET_POST.replace(
            '{customer_id}',
            customerId
        );

        delete payload.customerId;

        return request.post(URL, payload);
    } catch (e) {
        console.debug(e);
    }
};

/**
 * Update customer inventory item
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
 *     "customerId": "md023bf9a",
 *     "inventoryId": "dfgsdgf2e",
 *     "name": "string",
 *     "quantity": 0,
 *     "value": 0
 * }
 */
export const customer_inventory__update = (request, payload) => {
    try {
        const { customerId, inventoryId } = payload;
        const URL = CUSTOMER_INVENTORY__PATCH_DELETE.replace(
            '{customer_id}',
            customerId
        ).replace('{inventory_id}', inventoryId);

        delete payload.customerId;
        delete payload.inventoryId;

        return request.patch(URL, payload);
    } catch (e) {
        console.debug(e);
    }
};

/**
 * Delete customer inventory item
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
 *     "customerId": "md023bf9a",
 *     "inventoryId": "safgq23rf3"
 * }
 */
export const customer_inventory__delete = (request, payload) => {
    try {
        const { customerId, inventoryId } = payload;
        const URL = CUSTOMER_INVENTORY__PATCH_DELETE.replace(
            '{customer_id}',
            customerId
        ).replace('{inventory_id}', inventoryId);

        return request.delete(URL);
    } catch (e) {
        console.debug(e);
    }
};

export const inventory_items_suggest = (request , payload)=>{


    try {
        const { query } = payload;
        const URL = "/suggest/inventory?q={query}".replace(
            '{query}',
            query
        );

        return request.get(URL);
    } catch (e) {
        console.debug(e);
    }


};

/**
 * Update a business primary person
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
      "customerId": "string",
      "title": "string",
      "firstName": "string",
      "lastName": "string",
      "association": "string",
      "email": "string",
      "primaryPhone": "string",
      "alternativePhone": "string",
      "primaryContact": true,
      "authorisedForAccount": true,
      "authorisedForRoom": true
    }
 */
export const people_primary__update = (request, payload) => {
    try {
        const { customerId } = payload;
        let URL = CUSTOMER_BUSINESS_PRIMARY.replace(
            '{customer_id}',
            customerId
        );

        delete payload.customerId;

        return request.put(URL, payload);
    } catch (e) {
        console.debug(e);
    }
};


export const people_primary__get = (request, payload) => {
    try {
        const { customerId } = payload;
        let URL = CUSTOMER_BUSINESS_PRIMARY.replace(
            '{customer_id}',
            customerId
        );

        return request.get(URL);
    } catch (e) {
        console.debug(e);
    }
};

/**
 * Gets store details
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
 *     "storeId": "md023bf9a",
 * }
 */
export const store__get = (request, payload) => {
    try {
        const { storeId } = payload;
        const URL = STORE_GET.replace('{storeId}', storeId);

        return request.get(URL);
    } catch (e) {
        console.debug(e);
    }
};

/**
 * Upload files
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
 *    "tag": "CP",
 *    "data": "string",
 *    "fileName": "string",
 *    "crop": {
 *      "x": 0,
 *      "y": 0,
 *      "width": 0,
 *      "height": 0
 *    }
 *  }
 */
export const files__create = (request, payload) => {
    try {
        const { customer_id } = payload;

        delete payload.customer_id;

        const URL = CUSTOMER_FILE__GET_UPLOAD.replace('{customer_id}', customer_id);

        return request.post(URL, payload);
    } catch (e) {
        console.debug(e);
    }
};

/**
 * Retrieve files
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
 *    "customer_id": "dsf2323r3",
 *  }
 */
export const files__list = (request, payload) => {
    try {
        const { customer_id } = payload;
        const URL = CUSTOMER_FILE__GET_UPLOAD.replace('{customer_id}', customer_id);

        return request.get(URL);
    } catch (e) {
        console.debug(e);
    }
};

/**
 * Retrieve a single files
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
 *    "customer_id": "dsf2323r3",
 *    "attachment_id": "dsf2323r3",
 *  }
 */
export const files__detail = (request, payload) => {
    try {
        const { customer_id, attachment_id } = payload;
        const URL = CUSTOMER_FILE__GET_ONE.replace('{customer_id}', customer_id).replace('{attachment_id}', attachment_id);

        return request.get(URL);
    } catch (e) {
        console.debug(e);
    }
};

/**
 * Delete files
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
 *    "customer_id": "dsf2323r3",
 *    "attachment_id": "dsf2323r3",
 *  }
 */
export const files__delete = (request, payload) => {
    try {
        const { customer_id, attachment_id } = payload;
        const URL = CUSTOMER_FILE__DELETE.replace('{customer_id}', customer_id).replace('{attachment_id}', attachment_id);

        return request.delete(URL, {data: {
                customerId: customer_id,
                attachmentId: attachment_id
            }});
    } catch (e) {
        console.debug(e);
    }
};

export const customer_link_reservation = (request, payload) => {
    try {
        const { userId } = payload;
        const URL = CUSTOMER_LINK_RESERVATION.replace(
            '{user_id}',
            userId
        );

        delete payload.userId;

        return request.post(URL, payload);
    } catch (e) {
        console.debug(e);
    }
};


export const customer_accounts__get = (request, payload) => {
    try {
        const { userId } = payload;
        const URL = CUSTOMER_ACCOUNTS.replace(
            '{user_id}',
            userId
        );

        delete payload.userId;

        return request.get(URL);
    } catch (e) {
        console.debug(e);
    }
};

export const customer_move_in_date__set = (request, payload) => {
    try {
        const {  reservationId} = payload;
        const URL = CUSTOMER_MOVE_IN_DATE_PATCH.replace(
            '{reservation_id}',
            reservationId
        );

        delete payload.customerId;
        return request.patch(URL, payload);
    } catch (e) {
        console.debug(e);
    }

}

/**
 * Get customer subcontracts
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
 *     "customerId": "md023bf9a",
 * }
 */
export const customer_subcontracts__get = (request, payload) => {
    try {
        const {customerId} = payload;
        const URL = CUSTOMER_SUBCONTRACTS.replace('{customer_id}', customerId);

        return request.get(URL);
    } catch (e) {
        console.debug(e);
    }
}

    export const customer_subcontracts__set = (request, payload) => {
        try {
            const {customerId, id} = payload;

            const URL = CUSTOMER_SUBCONTRACTS__PATCH.replace('{customer_id}', customerId).replace('{subContractId}', id);

            delete payload.customerId;
            delete payload.id;

            return request.patch(URL, payload);


        } catch (e) {
            console.debug(e);
        }
    };

export const customer_contract_reasons__get = (request) => {
    try {
        return request.get(CUSTOMER_SUBCONTRACTS_REASONS);
    } catch (e) {
        console.debug(e);
    }
};
export const customer_donation__get = (request, payload) => {
    try {
        const {customerId} = payload;
        let URL = CUSTOMER_DONATION.replace(
            '{customer_id}',
            customerId
        );

        return request.get(URL);
    } catch (e) {
        console.debug(e);
    }
};

export const customer_donation__set = (request, payload) => {
    try {
        const {customerId} = payload;
        const URL = CUSTOMER_DONATION.replace(
            '{customer_id}',
            customerId
        );

        delete payload.customerId;

        return request.patch(URL, payload);
    } catch (e) {
        console.debug(e);
    }
};

/**
 *
 * @param request
 * @param payload = {"code": "ABC123","email": "...", "password": "..."} 
 * @returns {*}
 */
export const update_user=(request , payload)=>{
    try {
        const {id} = payload;
        const URL = USER.replace(
          '{user_id}',
          id
        );

        delete payload.customerId;

        return request.patch(URL, payload);
    } catch (e) {
        console.debug(e);
    }

}

export  const get_move_in_blocked_dates = (request) => {
    try {

        return request.get(MOVE_IN_BLOCKED_DATES);
    } catch (e) {
        console.debug(e);
    }
}
/**
 *
 * @param request
 * @param payload = {"password": "..."}
 * @returns {*}
 */
export const verify_password=(request , payload)=>{
    try {
        const {id} = payload;
        const URL = PASSWORD_VERIFY;

        delete payload.customerId;

        return request.post(URL, payload);
    } catch (e) {
        console.debug(e);
    }
}
export  const getYotiIdentificationProgress = (request , payload)=>{

    try {
        const { customerId } = payload;
        const URL = YOTI_ACCOUNT_HOLDER_PROGRESS.replace('{customer_id}', customerId);
        return request.get(URL, payload);
    } catch (e) {
        console.debug(e);
    }
}

export const by_log = (request, log_level, message, context = {}) => {
    //{"log_level":"error","message":"there was an error","context:{"foo":bar"}}

    if (parseInt(process.env.NEXT_PUBLIC_DISABLE_REMOTE_LOGGING ?? '0') === 1) {
        console.log('INFO: Development bypass for logging enabled.');
        return;
    }

    let msgType = typeof message;

    if ('string' !== msgType) {
        if ('object' === msgType) {
            msgType = message.constructor.name;
        }
        context = {
            "original message": message,
            "message type": msgType,
            "document.referer": document.referrer,
            ...context
        };
        message = 'Invalid log message found, see context.';

    } else {
        context = {
            "document.referer": document.referrer,
            ...context
        };
    }

    let payload = {log_level: log_level, message: message, context: context};

    try {
        return request.post(LOGGER, payload);
    } catch (e) {
        console.debug(e);
    }
};
